<template>
  <v-card class="fill-height d-flex flex-column">
    <v-row no-gutters align="center" class="px-2" style="border-bottom: 1px solid #e2e2e2">
      <v-col cols="auto">
        <v-row no-gutters class="align-center fill-height" style="min-height: 36px">
          <v-col cols="auto">
            <span>
              {{ tabTitle }}
            </span>
            <slot name="append-title" />
          </v-col>
        </v-row>
      </v-col>
      <slot name="navbar-content" />
    </v-row>
    <span v-show="tableHeight > 0" class="body-wrapper">
      <slot name="body" />
    </span>
  </v-card>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'BottomDrawerWrapper',
  props: {
    tabTitle: {
      type: String,
      default: null,
    },
  },
  computed: {
    tableHeight: get('table/tableHeight'),
  },
};
</script>

<style lang="scss" scoped>
.body-wrapper {
  height: 100%;
  width: 100%;
  min-height: 0;
}
</style>
